import * as React from "react";
import VideoThumbnail, {Video} from "./VideoThumbnail";
import {YouTubeService} from "./YouTubeService";
import {DialogComponent} from "@syncfusion/ej2-react-popups";
import ReactPlayer from "react-player";


type State = {
    showDialog: boolean;
    loading: boolean;
    videos: Video[];
    error: any | null;
    selectedVideo: any | null;
}

interface Props {
    searchQuery: string;
}

export default class VideoList extends React.Component<Props, State> {


    constructor(props: Props | Readonly<Props>) {
        super(props);
        this.state = {
            videos: [],
            loading: true,
            error: null,
            selectedVideo: null,
            showDialog: false,
        };
    }

    onVideoClick = (video: any) => {
        this.setState({ selectedVideo: video, showDialog: true });
    };

    hideDialog = () => {
        this.setState({ showDialog: false });
    };

    filterVideos(query: string) {
        const lowercasedQuery = query.toLowerCase();
        return this.state.videos.filter((video) =>
            video.snippet.title.toLowerCase().includes(lowercasedQuery) ||
            video.snippet.description.toLowerCase().includes(lowercasedQuery)
        );
    }


    async componentDidUpdate(prevProps: Props) {
        if (prevProps.searchQuery !== this.props.searchQuery) {
            this.setState({ loading: true });
            try {
                const videos = await YouTubeService.getPlaylistSearch(this.props.searchQuery);
                this.setState({ videos, loading: false });
            } catch (error) {
                this.setState({ error, loading: false });
            }
        }
    }

    getVideoId = (video: Video) => {
        const id =  video.id?.videoId || video.snippet.resourceId?.videoId;
        const title = video.snippet.title;
        console.log({title, id})
        return id;
    };


    async componentDidMount() {
        try {
            const videos = await YouTubeService.getPlaylistItems();
            this.setState({ videos, loading: false });
        } catch (error) {
            this.setState({ error, loading: false });
        }
    }

    render() {
        const { loading, videos, error, showDialog, selectedVideo } = this.state;

        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error loading videos.</div>;
        console.log(selectedVideo?.contentDetails)

        return (
            <>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {videos.map((video) => (
                        <VideoThumbnail key={this.getVideoId(video)} video={video} onClick={this.onVideoClick} />
                    ))}
                </div>
                {selectedVideo && (
                    <DialogComponent
                        visible={showDialog}
                        header={selectedVideo.snippet.title}
                        width="800px"
                        height="800px"
                        resizeHandles={['All']}
                        allowDragging={true}
                        isModal={true}
                        showCloseIcon={true}
                        close={this.hideDialog}
                    >

                        <ReactPlayer
                            url={`https://www.youtube.com/embed/${this.getVideoId(selectedVideo)}`}
                            playing={showDialog}
                            controls={true}
                            width="100%"
                            height="95%"
                        />

                    </DialogComponent>
                )}
            </>
        );
    }
}
